import {
  buildIntelQueryObject,
  createIntelWorkspaceItem,
} from '@pn/core/domain/intel/intel-workspace-item';
import type { Filter } from '@pn/core/domain/query';
import { isNil } from 'lodash-es';
import type { ReportFiltersAndId } from 'src/application/intel-templates/activityOverview';

export function generateWellMismatches({
  startDate,
  endDate,
  formation,
  companyBrandName,
  fieldName,
  geoJSONGeometry,
  linkedReportId,
}: ReportFiltersAndId) {
  const mismatchesFilters: Filter[] = [
    {
      field: 'licenses.license_date',
      operator: '>=',
      value: startDate,
    },
    {
      field: 'licenses.license_date',
      operator: '<=',
      value: endDate,
    },
  ];

  if (!isNil(geoJSONGeometry)) {
    mismatchesFilters.push({
      field: 'wellbores.geom',
      operator: 'intersects',
      value: geoJSONGeometry as any,
    });
  }

  if (!isNil(formation)) {
    mismatchesFilters.push({
      field: 'wellbores.formation',
      operator: 'contains',
      value: formation,
    });
  }
  if (!isNil(companyBrandName)) {
    mismatchesFilters.push({
      field: 'licensee_brand.display_name',
      operator: '=',
      value: companyBrandName,
    });
  }

  if (!isNil(fieldName)) {
    mismatchesFilters.push({
      field: 'wellbores.field_name',
      operator: 'ILIKE',
      value: fieldName,
    });
  }

  return [
    createIntelWorkspaceItem({
      name: 'Well Mismatches',
      query: buildIntelQueryObject('well_licence_mismatches', {
        filters: mismatchesFilters,
      }),
      linkedReportId,
    }),
  ];
}
